import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  fullWidthOnMobile?: boolean;
  className?: string;
};
export function CtaButton({
  href,
  children,
  size = 'lg',
  fullWidthOnMobile = true,
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'min-h-14 px-5 py-3 text-[14px] sm:min-h-16 sm:px-8 sm:text-base' : 'min-h-11 px-4 py-2 text-[13px] sm:text-sm';
  return <a href={href} className={`group inline-flex items-center justify-center gap-2.5 text-center leading-tight sm:whitespace-nowrap rounded-xl bg-pumpkin font-display font-extrabold uppercase tracking-wide text-ink shadow-[0_10px_30px_-10px_rgba(242,112,29,0.7)] transition-[background-color,transform] duration-150 ease-out hover:bg-pumpkin-light active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-night ${sizing} ${fullWidthOnMobile ? 'w-full sm:w-auto' : ''} ${className}`} data-id="element-2" data-mp="llqsgytbrfyd">
      <span data-id="element-3" data-mp="39yrgxlaii6mp">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-4" data-mp="39xzk6756i2uu" />
    </a>;
}